import { useState } from 'react';
import { useIsNative } from '~/context/srp/DeviceContext';
import useCheckExperimentBucket from '~/hooks/srp/useCheckExperimentBucket';

export const useKeywordSearch = () => {
  const [inputFocus, setInputFocus] = useState(false);

  return {
    inputFocus,
    setInputFocus
  };
};

export const useShouldRenderMerchSearchBar = () => {
  const isInDefaultSuggestionsExperiment = useCheckExperimentBucket(
    'srch-home-text-search-default',
    'experiment'
  );
  const isNative = useIsNative();

  return isInDefaultSuggestionsExperiment && !isNative;
};
